// sweetalert2-utils.js
import Swal from 'sweetalert2';

export const showSuccessAlert = (message = 'ดำเนินการสำเร็จ!') => {
  return Swal.fire({
    icon: 'success',
    title: 'สำเร็จ',
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
};

export const showErrorAlert = (message = 'เกิดข้อผิดพลาด!') => {
  return Swal.fire({
    icon: 'error',
    title: 'ข้อผิดพลาด',
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
};

export const showCreateAlert = (message = 'เพิ่มรายการเรียบร้อยแล้ว!') => {
  return Swal.fire({
    icon: 'success',
    title: 'สำเร็จ',
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
};

export const showUpdateAlert = (message = 'อัพเดทรายการเรียบร้อยแล้ว!') => {
  return Swal.fire({
    icon: 'success',
    title: 'สำเร็จ',
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
};

export const showDeleteAlert = (message = 'ลบรายการเรียบร้อยแล้ว!') => {
  return Swal.fire({
    icon: 'success',
    title: 'สำเร็จ',
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
};

export const showConfirm = (message = 'คุณต้องการลบรายการนี้หรือไม่?', confirmButtonText = 'ใช่, ยืนยัน') => {
  return Swal.fire({
    title: 'ยืนยันการลบข้อมูลนี้',
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: confirmButtonText,
    cancelButtonText: 'ไม่',
  });
};